import { render, staticRenderFns } from "./ThanhToanThem.vue?vue&type=template&id=0485ad25&"
import script from "./ThanhToanThem.vue?vue&type=script&lang=js&"
export * from "./ThanhToanThem.vue?vue&type=script&lang=js&"
import style0 from "./ThanhToanThem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports